/**
 * @param state {object} Domain state
 * @param newActiveCart {object|null} New active cart
 * @param submittedCartId {string} ID of the submitted cart
 * @returns {object} Updated domain state
 */
import saveCartReducer from './saveCartReducer';


export default (state, {newActiveCart, submittedCartId}) => {

    delete state.carts[submittedCartId];

    return saveCartReducer(state, newActiveCart);
};
